import { useMemo } from "react";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { isTreatmentContainer } from "../Helpers/treatmentsHelpers";
import { useFilteredTreatments } from "./useFilteredTreatments";

export function useFilteredTreatment(
  treatment: TreatmentsContainerDto,
  location: LocationDto,
  doctor: DoctorDto,
  isDoctorPageBooking?: boolean
): TreatmentsContainerDto {
  const treatmentArray = useMemo(() => [treatment], [treatment]);
  const filteredTreatments = useFilteredTreatments(treatmentArray, location, doctor, undefined, isDoctorPageBooking);
  const result = filteredTreatments[0];

  if (!result || !isTreatmentContainer(result)) {
    return {
      ...treatment,
      items: []
    };
  }

  return result;
}
